import React from 'react';
import PropTypes from 'prop-types';
import { SuiLabel } from '@splashthat/sui';

import Input from 'common/icons/Input';
import Dropdown from 'common/icons/Dropdown';

import { DROPDOWN_INPUT_TYPE, TEXT_INPUT_TYPE } from 'common/entities/form/styleConfiguration/constants';

import CustomElementTypeTabsSelector from '../CustomElementTypeTabsSelector';

const DROPDOWN_INPUT_LABEL = 'Dropdown';
const TEXT_INPUT_LABEL = 'Text Input';

const INPUT_TYPES = [
    {
        icon: Dropdown,
        label: DROPDOWN_INPUT_LABEL,
        value: DROPDOWN_INPUT_TYPE,
    },
    {
        icon: Input,
        label: TEXT_INPUT_LABEL,
        value: TEXT_INPUT_TYPE,
    },
];

const InputTypeEditor = (props) => (
    <React.Fragment>
        {props.label && <SuiLabel text={props.label} />}
        <CustomElementTypeTabsSelector
            tabs={INPUT_TYPES}
            value={props.inputType}
            onChange={props.onChangeInputType}
            qaId={props.qaId}
        />
    </React.Fragment>
);

InputTypeEditor.propTypes = {
    inputType: PropTypes.string.isRequired,
    onChangeInputType: PropTypes.func.isRequired,
    qaId: PropTypes.string.isRequired,
    label: PropTypes.string,
};

InputTypeEditor.defaultProps = {
    label: undefined,
};

export default InputTypeEditor;
